import { Domain as DomainType } from 'Types/Domain'
import {
  Connected,
  DisabledProduct,
} from 'Features/domainsManagement/components/DomainManagmentRow/DomainManagementRow.styled'
import { Setup } from 'Features/domainsManagement/components/Setup/Setup'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUserStore } from 'Stores/userStoreModuleFed'

type PaidMarketingButtonProps = {
  domain: DomainType
  openPlatformConnectionModal: () => void
}

export const PaidMarketingButton = ({
  domain,
  openPlatformConnectionModal,
}: PaidMarketingButtonProps) => {
  const { t } = useTranslation('domainManagement')
  const { owner } = useUserStore()

  if (domain.paidMarketing) {
    return domain.paidMarketingConnected ? (
      <Connected>{t('connected')}</Connected>
    ) : (
      <Setup
        onClick={() => {
          openPlatformConnectionModal()
        }}
        disabled={!owner}
      />
    )
  } else {
    return <DisabledProduct>{t('disabled')}</DisabledProduct>
  }
}
